export default function getAtom(nucleus) {
    return nucleus?.replace(/\d/g, '') || '';
}
